<template>
  <div>
    <validation-provider
        v-slot="validationContext"
        name="Link Başlığı"
        rules="required"
      >
        <b-form-group
          label="Banner Başlığı"
          label-for="campaign_name"
        >
          <b-form-input
            id="campaign_name"
            v-model="localValue.campaign_name"
            :state="getValidationState(validationContext)"
            @input="emitUpdate"
            trim
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    
    
    <b-form-group label="Banner Yükle">
      <b-form-file
        accept="image/jpeg, image/png, image/gif"
        @change="handleFileChange"
      />
    </b-form-group> 

    
    </div>
  </template>
  
  <script>
  import { 
    BFormGroup, 
    BInputGroup, 
    BFormFile, 
    BFormInvalidFeedback,
    BFormInput
  } from 'bootstrap-vue'
  import { ValidationProvider } from 'vee-validate'
  import vSelect from 'vue-select'
  import { computed } from '@vue/composition-api'
  import formValidation from '@core/comp-functions/forms/form-validation'


  export default {
    name: 'BannerForm',
    components: {
      BFormGroup,
      BInputGroup,
      vSelect,
      BFormInput,
      BFormFile,
      BFormInvalidFeedback,
      ValidationProvider
    },
    props: {
      linkData: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        localValue: { ...this.linkData },
      }
    },
    emits: ['file-change'],
    setup(props, { emit }) {
      const prependValue = computed(() => 'banner-')
      
      const { getValidationState } = formValidation()
  
      const handleFileChange = (event) => {
        const file = event.target.files[0]
        emit('file-change', file)
      }
      
      return {
        prependValue,
        getValidationState,
        handleFileChange
      }
    },
    watch: {
      linkData: {
        handler(newVal) {
          this.localValue = { ...newVal }
        },
        deep: true
      },
      'localValue.group_id': function () {
        this.emitUpdate()
      },
    },
    mounted() {
    },
    methods: {
      emitUpdate() {
        this.$emit('update', { ...this.localValue })
      },
    }
  }
  </script>